import {
  MAPY_CZ_TILE_LAYERS,
  MAPY_CZ_TILE_LAYER_MAX_ZOOM,
  MAPY_CZ_TILE_LAYER_MIN_ZOOM,
  mapyCzTileLayerUrl,
} from '@ngsos/portal-core/incidents';
import type { TileLayer } from '@/lib/leaflet/leafletMap';

const MAPY_CZ_ATTRIBUTION =
  '<img src="https://api.mapy.cz/img/api/logo.svg" alt="Zobrazit na Mapy.cz" crossorigin="true">';

export function mapyCzLayers(
  language: string,
  mapyCzApiKey: string,
  translate: (key: string) => string,
): TileLayer[] {
  return MAPY_CZ_TILE_LAYERS.map((layer) => ({
    id: layer.id,
    name: translate(layer.nameKey),
    urlTemplate: mapyCzTileLayerUrl(layer.tileSetId, language, mapyCzApiKey),
    minZoom: MAPY_CZ_TILE_LAYER_MIN_ZOOM,
    maxZoom: MAPY_CZ_TILE_LAYER_MAX_ZOOM,
    attribution: MAPY_CZ_ATTRIBUTION,
    isDefault: layer.isDefault,
    isUsedForFullZoom: layer.isUsedForFullZoom,
  }));
}
